/** @format */
import { useGlobalStoreWithOut } from '@/store/modules/global';
import { initPData } from '@/utils/p-data';

export * from '@/enums';
export * from '@/utils';
export * from '@/hooks';
export * from '@/api';
export * from '@/store';

initPData();

async function init(force = false) {
	const globalStore = useGlobalStoreWithOut();
	if (globalStore.stateLoading === 'init' || force) {
		globalStore.setStateLoading('isLoading');

		try {
			await globalStore.initData();
			globalStore.setStateLoading('loaded');
		} catch (error) {
			console.log('error', error);
		}
	}
}
if ('development' === import.meta.env.VITE_APP_ENV) {
	init();
}

async function beforeInit(callback) {
	const globalStore = useGlobalStoreWithOut();
	if (callback) {
		await callback({ globalStore });
	}
}

export { beforeInit, init };
